"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterMarkerStops = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../icons");
var types_1 = require("../../types");
var utils_1 = require("../utils");
var digitMap = {
    "12": icons_1.Marker1c2d,
    "13": icons_1.Marker1c4d,
    "14": icons_1.Marker1c4d,
    "15": icons_1.Marker1c6d,
    "16": icons_1.Marker1c6d,
    "22": icons_1.Marker2c2d,
    "23": icons_1.Marker2c4d,
    "24": icons_1.Marker2c4d,
    "25": icons_1.Marker2c6d,
    "26": icons_1.Marker2c6d,
    "32": icons_1.Marker3c2d,
    "33": icons_1.Marker3c4d,
    "34": icons_1.Marker3c4d,
    "35": icons_1.Marker3c6d,
    "36": icons_1.Marker3c6d,
    "42": icons_1.Marker4c2d,
    "43": icons_1.Marker4c4d,
    "44": icons_1.Marker4c4d,
    "45": icons_1.Marker4c6d,
    "46": icons_1.Marker4c6d,
    "52": icons_1.Marker5c2d,
    "53": icons_1.Marker5c4d,
    "54": icons_1.Marker5c4d,
    "55": icons_1.Marker5c6d,
    "56": icons_1.Marker5c6d,
    "62": icons_1.Marker6c2d,
    "63": icons_1.Marker6c2d,
    "64": icons_1.Marker6c4d,
    "65": icons_1.Marker6c6d,
    "66": icons_1.Marker6c6d,
};
var digitMapCurrent = {
    "12": icons_1.Marker1c2dCurrent,
    "13": icons_1.Marker1c4dCurrent,
    "14": icons_1.Marker1c4dCurrent,
    "15": icons_1.Marker1c6dCurrent,
    "16": icons_1.Marker1c6dCurrent,
    "22": icons_1.Marker2c2dCurrent,
    "23": icons_1.Marker2c4dCurrent,
    "24": icons_1.Marker2c4dCurrent,
    "25": icons_1.Marker2c6dCurrent,
    "26": icons_1.Marker2c6dCurrent,
    "32": icons_1.Marker3c2dCurrent,
    "33": icons_1.Marker3c4dCurrent,
    "34": icons_1.Marker3c4dCurrent,
    "35": icons_1.Marker3c6dCurrent,
    "36": icons_1.Marker3c6dCurrent,
    "42": icons_1.Marker4c2dCurrent,
    "43": icons_1.Marker4c4dCurrent,
    "44": icons_1.Marker4c4dCurrent,
    "45": icons_1.Marker4c6dCurrent,
    "46": icons_1.Marker4c6dCurrent,
    "52": icons_1.Marker5c2dCurrent,
    "53": icons_1.Marker5c4dCurrent,
    "54": icons_1.Marker5c4dCurrent,
    "55": icons_1.Marker5c6dCurrent,
    "56": icons_1.Marker5c6dCurrent,
    "62": icons_1.Marker6c2dCurrent,
    "63": icons_1.Marker6c4dCurrent,
    "64": icons_1.Marker6c4dCurrent,
    "65": icons_1.Marker6c6dCurrent,
    "66": icons_1.Marker6c6dCurrent,
};
var ClusterMarkerStops = function (_a) {
    var stopTypes = _a.stopTypes, circles = _a.circles, digit = _a.digit, hover = _a.hover, isCurrent = _a.isCurrent;
    var Marker;
    if (isCurrent) {
        Marker = digitMapCurrent[utils_1.getLength(circles.length).toString() + digit];
    }
    else {
        Marker = digitMap[utils_1.getLength(circles.length).toString() + digit];
    }
    if (hover &&
        ((stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.PENDING_CONTAINER_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.PENDING_INQUIRY_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CREATED_INQUIRY_EMPTIED)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CREATED_INQUIRY_NON_EMPTIED)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CURRENT_INQUIRY_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CURRENT_CONTAINER_STOP)))) {
        return (react_1.default.createElement(Marker, { size: 15, circles: circles, color: "#F2F2F2", strokeColor: "#909DA9" }));
    }
    if (!hover &&
        ((stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.PENDING_CONTAINER_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.PENDING_INQUIRY_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CREATED_INQUIRY_EMPTIED)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CREATED_INQUIRY_NON_EMPTIED)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CURRENT_INQUIRY_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.CURRENT_CONTAINER_STOP)))) {
        return (react_1.default.createElement(Marker, { color: "white", size: 15, strokeColor: "#909DA9", circles: circles }));
    }
    if (hover &&
        ((stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.COMPLETE_CONTAINER_STOP)) ||
            (stopTypes === null || stopTypes === void 0 ? void 0 : stopTypes.includes(types_1.StopType.COMPLETE_INQUIRY_STOP)))) {
        return (react_1.default.createElement(Marker, { size: 15, circles: circles, color: "#F2F2F2", strokeColor: "#F2F2F2" }));
    }
    return (react_1.default.createElement(Marker, { size: 15, circles: circles, color: "white", strokeColor: "white" }));
};
exports.ClusterMarkerStops = ClusterMarkerStops;
